import { Link } from "react-router-dom";

// Full brand mark — emblem + wordmark + tagline all baked in. Stored locally to
// avoid third-party CDN dependency and to keep versioning under git.
export const LOGO_URL = "/samara-logo.png";

export default function Logo({ light = false, compact = false }) {
  // Compact — mobile / tight spaces: same mark at smaller size.
  const sizeCls = compact
    ? "h-10"
    : "h-12 sm:h-14";

  // Light variant sits on a dark background (sidebar). Wrap in a subtle white
  // pill so the navy wordmark and multi-colour tagline stay legible.
  const wrapCls = light
    ? "bg-white/95 rounded-sm px-2 py-1 shadow-sm"
    : "";

  return (
    <Link
      to="/"
      data-testid="logo-link"
      aria-label="Samara Wiz — Health, Education, Beauty"
      className={`inline-flex items-center ${wrapCls}`}
    >
      <img
        src={LOGO_URL}
        alt="Samara Wiz — Health · Education · Beauty"
        className={`${sizeCls} w-auto object-contain select-none`}
        draggable={false}
        loading="eager"
      />
    </Link>
  );
}
